export enum HealthReportsGetters {
    GET_AVAILABLE_REPORTS = 'GET_AVAILABLE_REPORTS',
    GET_MANAGEMENT_VIEW = 'GET_MANAGEMENT_VIEW',
}
